import animation from '/assets/scripts/animation.js';
import cookies from '/assets/scripts/cookies.js';
import extra from '/assets/scripts/extra.js';
import forms from '/assets/scripts/forms.js';
import slider from '/assets/scripts/slider.js';
// import transition from '/assets/scripts/transition.js';

document.addEventListener('DOMContentLoaded', function() {
  // transition();
  slider();
  extra();
  cookies();
  forms();
  animation();
});
